module.exports = {
  __depends__: [
    require(6),
    require(11)
  ]
};